import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

function FirebaseUser({
  displayName,
  email,
  emailStatus,
  photoURL,
  authProviderData,
  providerIds,
}) {
  return (
    <>
      <Grid item xs={4}>
        <Typography variant="h5">Firebase</Typography>
        {/* Name */}
        <Typography variant="body2">
          {displayName} {!displayName && '-'}
        </Typography>
        {/* Email */}
        <Typography variant="body2">
          {email && `${email} (${emailStatus})`} {!email && '-'}
        </Typography>
        {photoURL && <img src={photoURL} alt="user" />}
      </Grid>
      <Grid item xs={4}>
        <Typography variant="h5">Provider Data</Typography>
        <Typography variant="body2">
          {authProviderData?.displayName}
          {!authProviderData.displayName && '-'}
        </Typography>
        <Typography variant="body2">
          {authProviderData?.email}
          {!authProviderData.email && '-'}
        </Typography>
        {authProviderData.photoURL && (
          <img src={authProviderData.photoURL} alt="user" />
        )}
        <Typography variant="h6">{providerIds}</Typography>
      </Grid>
    </>
  );
}

export default FirebaseUser;
